module.exports = __webpack_public_path__ + "assets/images/psychologic_r.e4639715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/psychologic_r.png
// module id = 762
// module chunks = 1